import * as angular from "angular";
import { StateService } from "@uirouter/angularjs";
import { PopUpService } from "@common/popup/popup.service";
import { CacheService } from "@common/service/cache.service";

interface IEcvPlansUsage {
    plan: any;
    crType: string;
    docType: string;
    discType: string;
    galType: string;
    init(): void;
}

class EcvPlansUsage implements IEcvPlansUsage {

    static $inject = ['CacheService', '$state', 'PopUpService'];

    plan: any;
    crType: string;
    docType: string;
    discType: string;
    galType: string;
    hasOwnedSubjects: boolean;
    constructor(private $_cache: CacheService, private $state: StateService, private $_popup: PopUpService) {

    }

    init(): void {
        this.crType = this.getProgressType(this.plan.currentUsage.careTeam, this.plan.maxCR);
        this.docType = this.getProgressType(this.plan.currentUsage.documents, this.plan.maxDocuments);
        this.discType = this.getProgressType(this.plan.currentUsage.discussions, this.plan.maxDiscussions);
        this.galType = this.getProgressType(this.plan.currentUsage.galleryPhotos, this.plan.maxGalleryPhotos);
        let user = this.$_cache.getUser();
        this.hasOwnedSubjects = (!!user.ownedSubjects && user.ownedSubjects.length > 0);
    }

    getProgressType(usage, max): string {
        if (max < 0) {
            return "success";
        }
        let res = usage / max;
        if (res == 1) {
            return "danger";
        }
        else if (res >= 0.8) {
            return "warning";
        }
        return "success";
    }

}

function ecvPlansUsage($timeout: ng.ITimeoutService): ng.IDirective {
    return {
        restrict: 'E',
        templateUrl: 'app/common/directive/plans-usage/template/plans-usage.directive.html',
        replace: true,
        controller: EcvPlansUsage,
        scope: true,
        controllerAs: 'plansUsageVm',
        bindToController: {
            'plan': '=plan'
        },
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: IEcvPlansUsage): void => {
            controller.init();
            scope.$watch(() => {
                return !!controller.plan ? controller.plan : null;
            }, (newVal, oldVal) => {
                if (!!newVal && newVal != oldVal) {
                    controller.init();
                }
            });
        }
    };
}

angular.module('eCareVault.common.directives').directive('ecvPlansUsage', ['$timeout', ecvPlansUsage]);
